var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
// TODO: should the buff values be rounded?
import * as Long from "long";
import { mapNumberRounding } from "../features/generic/round-format/mapNumberRounding";
import { TypeNumberRounding } from "../features/generic/round-format/TypeNumberRounding";
import { BuffContextType, BuffHierarchyType, BuffTargetType, } from "./network/generated/protoTypes";
var UtilBuff = /** @class */ (function () {
    function UtilBuff() {
        var _this = this;
        this.remainingTimeKey = "remainingTime";
        this.summableFields = [
            "addition",
            "factorMultiplication",
            "factorAdditionMultiplicationTarget",
            "factorMultiplication",
            "onTop",
        ];
        this.applyTo = function (value, buff, roundingId) {
            if (roundingId === void 0) { roundingId = TypeNumberRounding.None; }
            var roundingMethod = mapNumberRounding.get(roundingId);
            var result = _this.calculateBuffApplication(value, buff);
            result = roundingMethod(result);
            return Long.fromValue(result);
        };
        this.sumBuffs = function (buff1, buff2) {
            var buffs = [buff1, buff2];
            var result = {};
            _this.summableFields.forEach(function (field) { return (result[field] = _this.sumBuffFields(buffs, field)); });
            return result;
        };
        this.calculateBuffAmount = function (buff, amount, roundingId) {
            if (roundingId === void 0) { roundingId = TypeNumberRounding.None; }
            var buffedAmount = Long.fromValue(amount);
            if (buff != undefined) {
                buffedAmount = utilBuff.applyTo(amount, buff, roundingId);
            }
            var buffAmount = buffedAmount.subtract(amount);
            return amount instanceof Long ? buffAmount : buffAmount.toNumber();
        };
        this.applyAddition = function (value, buffFraction) {
            return value + Math.round(value * buffFraction);
        };
        this.applySubtraction = function (value, buffFraction) {
            return value - Math.round(value * buffFraction);
        };
        this.buffAdditionValue = function (value, buffFraction) {
            return Math.round(value * buffFraction);
        };
        this.longBuffAdditionValue = function (value, buffFraction) {
            return value.multiply(buffFraction);
        };
        this.groupByRemainingTime = function (buffs) {
            return buffs.reduce(function (acc, obj) {
                var key = obj[_this.remainingTimeKey];
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
            }, {});
        };
        this.convertToIBuffParam = function (buffType) {
            var name = buffType.name, hierarchy = buffType.hierarchy, context = buffType.context, target = buffType.target, otherProperties = __rest(buffType, ["name", "hierarchy", "context", "target"]);
            return __assign({ context: BuffContextType[context], hierarchy: BuffHierarchyType[hierarchy], target: BuffTargetType[target] }, otherProperties);
        };
        this.factorMultiplicationToPercentage = function (factorMultiplication) {
            return (1 - factorMultiplication) * 100;
        };
        // TODO: change this method so that able to multiply long numbers with decimals
        this.calculateBuffApplication = function (value, buff) {
            var val = value instanceof Long ? value.toNumber() : value;
            var result = val + (buff.addition || 0);
            result *=
                1 +
                    (buff.factorAddition || 0) +
                    (buff.factorAdditionMultiplicationTarget || 0) *
                        (1 + (buff.factorAdditionMultiplication || 0));
            result *= buff.factorMultiplication || 1;
            result += buff.onTop || 0;
            return result;
        };
        this.sumBuffFields = function (buffs, key) {
            return buffs.reduce(function (acc, buff) {
                if (typeof buff[key] !== "number") {
                    return acc;
                }
                return acc + buff[key];
            }, 0);
        };
    }
    return UtilBuff;
}());
export var utilBuff = new UtilBuff();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilBuff.ts
// module id = 132
// module chunks = 3